<template>
  <ul class="time-counter">
    <li v-for="item of times" :key="item.type">
      {{ String(item.value).padStart(2, "0")
      }}<em>{{ $t("timer." + item.type) }}</em>
    </li>
  </ul>
</template>

<script lang="ts" setup>
import { computed, onMounted, onUnmounted, ref } from "vue";

const props = defineProps<{
  time: number;
}>();

let timerId: number;

const remainingTime = ref(props.time - new Date().getTime());

const times = computed(() => {
  return [
    {
      type: "days",
      value: Math.floor(remainingTime.value / (1000 * 60 * 60 * 24)),
    },
    {
      type: "hours",
      value: Math.floor((remainingTime.value / (1000 * 60 * 60)) % 24),
    },
    {
      type: "minutes",
      value: Math.floor((remainingTime.value / 1000 / 60) % 60),
    },
    { type: "seconds", value: Math.floor((remainingTime.value / 1000) % 60) },
  ].filter((t) => t.value > 0 || t.type === "seconds");
});

const onTimeout = () => {
  location.reload();
};

onMounted(() => {
  timerId = setInterval(() => {
    const value = props.time - new Date().getTime();
    remainingTime.value = value > 0 ? value : 0;

    if (remainingTime.value === 0) {
      clearInterval(timerId);
      onTimeout();
    }
  }, 1000);
});

onUnmounted(() => {
  clearInterval(timerId);
});
</script>
